// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/dashboard/v1/private/dashboard.proto" (package "c1.api.dashboard.v1.private", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetDashboardRequest
 */
export interface GetDashboardRequest {
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.DirectoryStateView
 */
export interface DirectoryStateView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool directory_connected = 2
     */
    directoryConnected: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.IntegrationsStateView
 */
export interface IntegrationsStateView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool slack_integrated = 2
     */
    slackIntegrated: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.TasksStateView
 */
export interface TasksStateView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool task_created = 2
     */
    taskCreated: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.AccessBundleStateView
 */
export interface AccessBundleStateView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: bool bundle_created = 2
     */
    bundleCreated: boolean;
    /**
     * @generated from protobuf field: bool bundle_has_applications = 3
     */
    bundleHasApplications: boolean;
    /**
     * @generated from protobuf field: bool bundle_has_users = 4
     */
    bundleHasUsers: boolean;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.DashboardView
 */
export interface DashboardView {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.DirectoryStateView directory_state = 2
     */
    directoryState?: DirectoryStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.IntegrationsStateView integrations_state = 3
     */
    integrationsState?: IntegrationsStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.TasksStateView tasks_state = 4
     */
    tasksState?: TasksStateView;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.AccessBundleStateView access_bundle_state = 5
     */
    accessBundleState?: AccessBundleStateView;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.CertifyTasks
 */
export interface CertifyTasks {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GrantTasks
 */
export interface GrantTasks {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.RevokeTasks
 */
export interface RevokeTasks {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.EnrollmentTasks
 */
export interface EnrollmentTasks {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.EntitlementGrants
 */
export interface EntitlementGrants {
    /**
     * @generated from protobuf field: int64 count_expiring = 1
     */
    countExpiring: number;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetTasksOverviewRequest
 */
export interface GetTasksOverviewRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetTasksOverviewResponse
 */
export interface GetTasksOverviewResponse {
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.CertifyTasks certify_tasks = 1
     */
    certifyTasks?: CertifyTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.GrantTasks grant_tasks = 2
     */
    grantTasks?: GrantTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.RevokeTasks revoke_tasks = 3
     */
    revokeTasks?: RevokeTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.EnrollmentTasks enrollment_tasks = 4
     */
    enrollmentTasks?: EnrollmentTasks;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetAccessOverviewRequest
 */
export interface GetAccessOverviewRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetAccessOverviewResponse
 */
export interface GetAccessOverviewResponse {
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.GrantTasks requests = 1
     */
    requests?: GrantTasks;
    /**
     * @generated from protobuf field: c1.api.dashboard.v1.private.EntitlementGrants grants = 2
     */
    grants?: EntitlementGrants;
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewRequest
 */
export interface GetConflictsOverviewRequest {
}
/**
 * @generated from protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewResponse
 */
export interface GetConflictsOverviewResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardRequest$Type extends MessageType<GetDashboardRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetDashboardRequest", []);
    }
    create(value?: PartialMessage<GetDashboardRequest>): GetDashboardRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetDashboardRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetDashboardRequest): GetDashboardRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetDashboardRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetDashboardRequest
 */
export const GetDashboardRequest = new GetDashboardRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DirectoryStateView$Type extends MessageType<DirectoryStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.DirectoryStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "directory_connected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<DirectoryStateView>): DirectoryStateView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.directoryConnected = false;
        if (value !== undefined)
            reflectionMergePartial<DirectoryStateView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DirectoryStateView): DirectoryStateView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool directory_connected */ 2:
                    message.directoryConnected = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DirectoryStateView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool directory_connected = 2; */
        if (message.directoryConnected !== false)
            writer.tag(2, WireType.Varint).bool(message.directoryConnected);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.DirectoryStateView
 */
export const DirectoryStateView = new DirectoryStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IntegrationsStateView$Type extends MessageType<IntegrationsStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.IntegrationsStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "slack_integrated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<IntegrationsStateView>): IntegrationsStateView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.slackIntegrated = false;
        if (value !== undefined)
            reflectionMergePartial<IntegrationsStateView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IntegrationsStateView): IntegrationsStateView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool slack_integrated */ 2:
                    message.slackIntegrated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IntegrationsStateView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool slack_integrated = 2; */
        if (message.slackIntegrated !== false)
            writer.tag(2, WireType.Varint).bool(message.slackIntegrated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.IntegrationsStateView
 */
export const IntegrationsStateView = new IntegrationsStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TasksStateView$Type extends MessageType<TasksStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.TasksStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "task_created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TasksStateView>): TasksStateView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.taskCreated = false;
        if (value !== undefined)
            reflectionMergePartial<TasksStateView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TasksStateView): TasksStateView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool task_created */ 2:
                    message.taskCreated = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TasksStateView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool task_created = 2; */
        if (message.taskCreated !== false)
            writer.tag(2, WireType.Varint).bool(message.taskCreated);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.TasksStateView
 */
export const TasksStateView = new TasksStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessBundleStateView$Type extends MessageType<AccessBundleStateView> {
    constructor() {
        super("c1.api.dashboard.v1.private.AccessBundleStateView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "bundle_created", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "bundle_has_applications", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "bundle_has_users", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessBundleStateView>): AccessBundleStateView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.bundleCreated = false;
        message.bundleHasApplications = false;
        message.bundleHasUsers = false;
        if (value !== undefined)
            reflectionMergePartial<AccessBundleStateView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessBundleStateView): AccessBundleStateView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* bool bundle_created */ 2:
                    message.bundleCreated = reader.bool();
                    break;
                case /* bool bundle_has_applications */ 3:
                    message.bundleHasApplications = reader.bool();
                    break;
                case /* bool bundle_has_users */ 4:
                    message.bundleHasUsers = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessBundleStateView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* bool bundle_created = 2; */
        if (message.bundleCreated !== false)
            writer.tag(2, WireType.Varint).bool(message.bundleCreated);
        /* bool bundle_has_applications = 3; */
        if (message.bundleHasApplications !== false)
            writer.tag(3, WireType.Varint).bool(message.bundleHasApplications);
        /* bool bundle_has_users = 4; */
        if (message.bundleHasUsers !== false)
            writer.tag(4, WireType.Varint).bool(message.bundleHasUsers);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.AccessBundleStateView
 */
export const AccessBundleStateView = new AccessBundleStateView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DashboardView$Type extends MessageType<DashboardView> {
    constructor() {
        super("c1.api.dashboard.v1.private.DashboardView", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "directory_state", kind: "message", T: () => DirectoryStateView },
            { no: 3, name: "integrations_state", kind: "message", T: () => IntegrationsStateView },
            { no: 4, name: "tasks_state", kind: "message", T: () => TasksStateView },
            { no: 5, name: "access_bundle_state", kind: "message", T: () => AccessBundleStateView }
        ]);
    }
    create(value?: PartialMessage<DashboardView>): DashboardView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<DashboardView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DashboardView): DashboardView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* c1.api.dashboard.v1.private.DirectoryStateView directory_state */ 2:
                    message.directoryState = DirectoryStateView.internalBinaryRead(reader, reader.uint32(), options, message.directoryState);
                    break;
                case /* c1.api.dashboard.v1.private.IntegrationsStateView integrations_state */ 3:
                    message.integrationsState = IntegrationsStateView.internalBinaryRead(reader, reader.uint32(), options, message.integrationsState);
                    break;
                case /* c1.api.dashboard.v1.private.TasksStateView tasks_state */ 4:
                    message.tasksState = TasksStateView.internalBinaryRead(reader, reader.uint32(), options, message.tasksState);
                    break;
                case /* c1.api.dashboard.v1.private.AccessBundleStateView access_bundle_state */ 5:
                    message.accessBundleState = AccessBundleStateView.internalBinaryRead(reader, reader.uint32(), options, message.accessBundleState);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DashboardView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* c1.api.dashboard.v1.private.DirectoryStateView directory_state = 2; */
        if (message.directoryState)
            DirectoryStateView.internalBinaryWrite(message.directoryState, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.IntegrationsStateView integrations_state = 3; */
        if (message.integrationsState)
            IntegrationsStateView.internalBinaryWrite(message.integrationsState, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.TasksStateView tasks_state = 4; */
        if (message.tasksState)
            TasksStateView.internalBinaryWrite(message.tasksState, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.AccessBundleStateView access_bundle_state = 5; */
        if (message.accessBundleState)
            AccessBundleStateView.internalBinaryWrite(message.accessBundleState, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.DashboardView
 */
export const DashboardView = new DashboardView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CertifyTasks$Type extends MessageType<CertifyTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.CertifyTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CertifyTasks>): CertifyTasks {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CertifyTasks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CertifyTasks): CertifyTasks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CertifyTasks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.CertifyTasks
 */
export const CertifyTasks = new CertifyTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantTasks$Type extends MessageType<GrantTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.GrantTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<GrantTasks>): GrantTasks {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GrantTasks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantTasks): GrantTasks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantTasks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GrantTasks
 */
export const GrantTasks = new GrantTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeTasks$Type extends MessageType<RevokeTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.RevokeTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RevokeTasks>): RevokeTasks {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<RevokeTasks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevokeTasks): RevokeTasks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevokeTasks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.RevokeTasks
 */
export const RevokeTasks = new RevokeTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EnrollmentTasks$Type extends MessageType<EnrollmentTasks> {
    constructor() {
        super("c1.api.dashboard.v1.private.EnrollmentTasks", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<EnrollmentTasks>): EnrollmentTasks {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<EnrollmentTasks>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EnrollmentTasks): EnrollmentTasks {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EnrollmentTasks, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.EnrollmentTasks
 */
export const EnrollmentTasks = new EnrollmentTasks$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EntitlementGrants$Type extends MessageType<EntitlementGrants> {
    constructor() {
        super("c1.api.dashboard.v1.private.EntitlementGrants", [
            { no: 1, name: "count_expiring", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<EntitlementGrants>): EntitlementGrants {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countExpiring = 0;
        if (value !== undefined)
            reflectionMergePartial<EntitlementGrants>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EntitlementGrants): EntitlementGrants {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count_expiring */ 1:
                    message.countExpiring = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EntitlementGrants, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count_expiring = 1; */
        if (message.countExpiring !== 0)
            writer.tag(1, WireType.Varint).int64(message.countExpiring);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.EntitlementGrants
 */
export const EntitlementGrants = new EntitlementGrants$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTasksOverviewRequest$Type extends MessageType<GetTasksOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetTasksOverviewRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetTasksOverviewRequest>): GetTasksOverviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        if (value !== undefined)
            reflectionMergePartial<GetTasksOverviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTasksOverviewRequest): GetTasksOverviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTasksOverviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetTasksOverviewRequest
 */
export const GetTasksOverviewRequest = new GetTasksOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTasksOverviewResponse$Type extends MessageType<GetTasksOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetTasksOverviewResponse", [
            { no: 1, name: "certify_tasks", kind: "message", T: () => CertifyTasks },
            { no: 2, name: "grant_tasks", kind: "message", T: () => GrantTasks },
            { no: 3, name: "revoke_tasks", kind: "message", T: () => RevokeTasks },
            { no: 4, name: "enrollment_tasks", kind: "message", T: () => EnrollmentTasks }
        ]);
    }
    create(value?: PartialMessage<GetTasksOverviewResponse>): GetTasksOverviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetTasksOverviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetTasksOverviewResponse): GetTasksOverviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.dashboard.v1.private.CertifyTasks certify_tasks */ 1:
                    message.certifyTasks = CertifyTasks.internalBinaryRead(reader, reader.uint32(), options, message.certifyTasks);
                    break;
                case /* c1.api.dashboard.v1.private.GrantTasks grant_tasks */ 2:
                    message.grantTasks = GrantTasks.internalBinaryRead(reader, reader.uint32(), options, message.grantTasks);
                    break;
                case /* c1.api.dashboard.v1.private.RevokeTasks revoke_tasks */ 3:
                    message.revokeTasks = RevokeTasks.internalBinaryRead(reader, reader.uint32(), options, message.revokeTasks);
                    break;
                case /* c1.api.dashboard.v1.private.EnrollmentTasks enrollment_tasks */ 4:
                    message.enrollmentTasks = EnrollmentTasks.internalBinaryRead(reader, reader.uint32(), options, message.enrollmentTasks);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetTasksOverviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.dashboard.v1.private.CertifyTasks certify_tasks = 1; */
        if (message.certifyTasks)
            CertifyTasks.internalBinaryWrite(message.certifyTasks, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.GrantTasks grant_tasks = 2; */
        if (message.grantTasks)
            GrantTasks.internalBinaryWrite(message.grantTasks, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.RevokeTasks revoke_tasks = 3; */
        if (message.revokeTasks)
            RevokeTasks.internalBinaryWrite(message.revokeTasks, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.EnrollmentTasks enrollment_tasks = 4; */
        if (message.enrollmentTasks)
            EnrollmentTasks.internalBinaryWrite(message.enrollmentTasks, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetTasksOverviewResponse
 */
export const GetTasksOverviewResponse = new GetTasksOverviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessOverviewRequest$Type extends MessageType<GetAccessOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetAccessOverviewRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAccessOverviewRequest>): GetAccessOverviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAccessOverviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessOverviewRequest): GetAccessOverviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessOverviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetAccessOverviewRequest
 */
export const GetAccessOverviewRequest = new GetAccessOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessOverviewResponse$Type extends MessageType<GetAccessOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetAccessOverviewResponse", [
            { no: 1, name: "requests", kind: "message", T: () => GrantTasks },
            { no: 2, name: "grants", kind: "message", T: () => EntitlementGrants }
        ]);
    }
    create(value?: PartialMessage<GetAccessOverviewResponse>): GetAccessOverviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAccessOverviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAccessOverviewResponse): GetAccessOverviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.dashboard.v1.private.GrantTasks requests */ 1:
                    message.requests = GrantTasks.internalBinaryRead(reader, reader.uint32(), options, message.requests);
                    break;
                case /* c1.api.dashboard.v1.private.EntitlementGrants grants */ 2:
                    message.grants = EntitlementGrants.internalBinaryRead(reader, reader.uint32(), options, message.grants);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAccessOverviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.dashboard.v1.private.GrantTasks requests = 1; */
        if (message.requests)
            GrantTasks.internalBinaryWrite(message.requests, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.dashboard.v1.private.EntitlementGrants grants = 2; */
        if (message.grants)
            EntitlementGrants.internalBinaryWrite(message.grants, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetAccessOverviewResponse
 */
export const GetAccessOverviewResponse = new GetAccessOverviewResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConflictsOverviewRequest$Type extends MessageType<GetConflictsOverviewRequest> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetConflictsOverviewRequest", []);
    }
    create(value?: PartialMessage<GetConflictsOverviewRequest>): GetConflictsOverviewRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetConflictsOverviewRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConflictsOverviewRequest): GetConflictsOverviewRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConflictsOverviewRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewRequest
 */
export const GetConflictsOverviewRequest = new GetConflictsOverviewRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetConflictsOverviewResponse$Type extends MessageType<GetConflictsOverviewResponse> {
    constructor() {
        super("c1.api.dashboard.v1.private.GetConflictsOverviewResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<GetConflictsOverviewResponse>): GetConflictsOverviewResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<GetConflictsOverviewResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetConflictsOverviewResponse): GetConflictsOverviewResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetConflictsOverviewResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.dashboard.v1.private.GetConflictsOverviewResponse
 */
export const GetConflictsOverviewResponse = new GetConflictsOverviewResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.dashboard.v1.private.Dashboard
 */
export const Dashboard = new ServiceType("c1.api.dashboard.v1.private.Dashboard", [
    { name: "GetDashboardState", options: { "authz.method": { role: "VIEWER" } }, I: GetDashboardRequest, O: DashboardView },
    { name: "GetTasksOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetTasksOverviewRequest, O: GetTasksOverviewResponse },
    { name: "GetAccessOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetAccessOverviewRequest, O: GetAccessOverviewResponse },
    { name: "GetConflictsOverview", options: { "authz.method": { role: "VIEWER" } }, I: GetConflictsOverviewRequest, O: GetConflictsOverviewResponse }
]);
